import { render, staticRenderFns } from "./RecurrenceAccordion.vue?vue&type=template&id=24696c3c"
import script from "./RecurrenceAccordion.vue?vue&type=script&lang=js"
export * from "./RecurrenceAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports